{
  "login": {
    "title": "Login",
    "email": "Email",
    "password": "Password",
    "forgotPassword": "Forgot password?",
    "login": "Login",
    "signInWithEmail": "Sign in with Email",
    "signInWithGoogle": "Sign in with Google",
    "limitedFeatures": "Plate checker only",
    "limitedFeaturesDescription": "To access all features, sign in with Google.",
    "noStaffAccess": "This account has no access to the call center. Ask an admin for an invite.",
    "staffDeactivated": "This account is deactivated. Ask an admin to reactivate it.",
    "useWorkspaceAccount": "Sign in with your clicknpark Google Workspace account.",
    "signInFailed": "Sign-in failed. Try again."
  }
}
